import styled from 'styled-components';
import { mediaMax, primaryColor } from '@styles/utils';

export const AuthLayoutContainer = styled.div`
  padding-top: 60px;
  display: grid;
  height: 100%;
  grid-template-columns: 1fr 2fr;
  overflow-y: auto;

  @media screen and (${mediaMax.tablet}) {
    display: flex;
  }
`;

export const AuthLayoutLeft = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (${mediaMax.tablet}) {
    display: none;
  }
`;

export const AuthLayoutLeftContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  background-color: ${primaryColor(100)};
  top: 0;
  left: 0;
  height: 100%;
  width: 33%;

  @media screen and (${mediaMax.tablet}) {
    display: none;
  }
`;

export const AuthLayoutLeftGridIcon = styled.img`
  position: absolute;
  left: 0;
  transform: translateX(-25%);
  bottom: 80px;
`;

export const AuthLayoutLeftAuthIcon = styled.img`
  position: absolute;
  right: -100px;
  bottom: 150px;

  @media screen and (max-width: 1350px) {
    display: none;
  }
`;

export const AuthLayoutRight = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (${mediaMax.tablet}) {
    width: 100%;
  }
`;
